import React, { useEffect, useContext, useState } from "react";
import { SuperSEO } from "react-super-seo";
import axios from "axios";
import { Card, Col, ListGroup, Row } from "react-bootstrap";
import PsContext from "../../context";
import { ServiceUrl } from "../../utils/serviceUrl";
import {
  groupByMultiple,
  LOADER_LOGO,
  makeUrl,
  momentDate,
  NO_IMAGE_LOGO_WIDE,
  upperCase,
} from "../../utils";
import { Link } from "react-router-dom";

const EventsList = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);

  const [dataList, setDataList] = useState([]);
  const [dataView, setDataView] = useState([]);

  useEffect(() => {
    loadData();
  }, [props.match.params]);

  const loadData = () => {
    setLoader(true);
    axios
      .get(
        ServiceUrl.LIST_PAGES +
          "?type=event&" +
          props.match.params.type +
          "=1&limit=20"
      )
      .then((res) => {
        if (res["data"].status == "1") {
          setDataList(res["data"].data);
        }
        setLoader(false);
      });
  };

  const field = (fieldName) => dataList[fieldName] || "";

  return (
    <div style={{ minHeight: "350px" }}>
      <section>
        <div className="head-2">
          <div className="container">
            <div className="head-2-inn head-2-inn-padd-top">
              <h1>
                {props.match.params.type
                  ? upperCase(props.match.params.type) + " EVENTS"
                  : "EVENTS LIST"}
              </h1>
            </div>
          </div>
        </div>
      </section>

      {loader && (
        <center className="py-5">
          <img src={LOADER_LOGO.default} />
        </center>
      )}
      <section>
        <div className="container com-sp pad-bot-70 pg-inn ps_min_height px-5">
          {dataList.length > 0 && (
            <>
              <SuperSEO title={"Events " + field("title")} lang="en" />

              <Row>
                {/* <Col md={12}> */}
                <div className="ho-event pg-eve-main">
                  <ul>
                    {dataList.map((item, i) => {
                      return (
                        <li style={{ fontFamily: "-moz-initial" }}>
                          <div className="ho-ev-date pg-eve-date">
                            <span>
                              {momentDate(item.active_from_date, "DD")}
                            </span>
                            <span>
                              {momentDate(item.active_from_date, "MMM,YYYY")}
                            </span>
                          </div>
                          <div className="ho-ev-link pg-eve-desc">
                            <a>
                              <h4>{item.title}</h4>
                            </a>
                            <p>
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: item.content_html,
                                }}
                              />
                            </p>
                            {/*<span>9:15 am – 5:00 pm</span>*/}
                          </div>
                          <div className="pg-eve-reg">
                            <Link
                              to={`/event/${item.id}/${makeUrl(item.title)}`}
                            >
                              Read More
                            </Link>
                          </div>
                        </li>
                      );
                    })}
                  </ul>
                </div>
                {/* </Col> */}
              </Row>
            </>
          )}
        </div>
      </section>
    </div>
  );
};

export default EventsList;
